<template>
    <v-container fluid class="grey lighten-5 my-0 px-0  py-0">
        <q-agent-lead-order-submenu></q-agent-lead-order-submenu>
        <v-row class="mx-5">
            <v-col cols=12>
                <h2>Lead Allocation Log
                    <v-btn @click="reset">
                        Reset
                    </v-btn>
                </h2>
            </v-col>
            <v-col cols="12">
                <q-lead-allocation-log-data-table ref="allocation_log"></q-lead-allocation-log-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QAgentLeadOrderSubmenu from '@/components/navigation/Submenus/QAgentLeadOrderSubmenu.vue';
import QLeadAllocationLogDataTable from '@/components/datatables/LeadOrders/QLeadAllocationLogDataTable.vue'

export default {
    components: {
        QAgentLeadOrderSubmenu,
        QLeadAllocationLogDataTable
    },
    methods: {
        'reset': function() {
            this.$refs.allocation_log.reset()
        }
    }
}
</script>
